var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 20.9836H2.03193C1.39886 20.9836 0.885986 20.4704 0.885986 19.8376V1.36673C0.885986 0.733744 1.39894 0.220795 2.03193 0.220795H20.5029C21.1357 0.220795 21.6488 0.733744 21.6488 1.36673V19.8376C21.6488 20.4705 21.1357 20.9836 20.5029 20.9836H15.212V12.9431H17.9108L18.3149 9.80956H15.212V7.80901C15.212 6.90178 15.4639 6.28353 16.7649 6.28353L18.4242 6.28281V3.48016C18.1372 3.44197 17.1522 3.35666 16.0063 3.35666C13.6139 3.35666 11.9761 4.81695 11.9761 7.49868V9.80956H9.27031V12.9431H11.9761V20.9836Z",
    fill: "#0081FE",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.36806a8032ef6f8d5bfdc6862ece81f4.svg";
export { ForwardRef as ReactComponent };